export const formatStorageValue = (val: string | null) => {
	try {
		return JSON.parse(val ?? "");
	} catch (_) {
		return val;
	}
};

export const getStorageItem = (key: string) => formatStorageValue(localStorage.getItem(key));

export const setStorageItem = (key: string, valueToStore: any) => {
	return localStorage.setItem(
		key,
		typeof valueToStore === "string" // If the value is a string, we don't need to stringify it
			? valueToStore
			: JSON.stringify(valueToStore),
	);
};

export const removeStorageItem = (key: string) => localStorage.removeItem(key);
